<template>
    <kiosk-layout formContainer>
        <step-form-heading :icon="faUsersMedical"> New Team </step-form-heading>

        <form-wrapper
            :sections="[
                { id: 'details', label: 'Details' },
                { id: 'sub-team', label: 'Sub Team' },
                { id: 'franchise-hub', label: 'Franchise Hub' },
                { id: 'owner', label: 'Owner' },
            ]"
        >
            <kiosk-team-form-details id="details" v-model="form" :externalResults="$externalResults" />
            <kiosk-team-form-sub-team id="sub-team" v-model="form" :externalResults="$externalResults" />
            <kiosk-team-form-franchise-hub id="franchise-hub" v-model="form" />
            <kiosk-team-form-owner id="owner" v-model="form" :externalResults="$externalResults" />

            <vx-sticky-footer>
                <vx-button href="/kiosk/teams" class="w-20" size="lg" color="muted"> Cancel </vx-button>
                <vx-button
                    @click="submit()"
                    data-test="submit-button"
                    class="grow"
                    size="lg"
                    color="primary"
                    :loading="submitting"
                >
                    Create
                </vx-button>
            </vx-sticky-footer>
        </form-wrapper>
    </kiosk-layout>
</template>
<script setup>
import KioskLayout from '../../KioskLayout.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import { faUsersMedical } from '@fortawesome/pro-solid-svg-icons';
import FormWrapper from '~/components/general/FormWrapper.vue';
import { VxStickyFooter, VxButton } from '@voxie/frontend-components';
import { ref } from 'vue';
import KioskTeamFormDetails from './KioskTeamFormDetails.vue';
import KioskTeamFormSubTeam from './KioskTeamFormSubTeam.vue';
import KioskTeamFormFranchiseHub from './KioskTeamFormFranchiseHub.vue';
import KioskTeamFormOwner from './KioskTeamFormOwner.vue';
import useVuelidate from '@vuelidate/core';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';
import { adminTeamsClient } from '~/services';
import { useCallout } from '~/composables/useCallout';
import { escapeHtml } from '~/utils/html';
import { e164Format } from '~/utils/phoneNumber';
import dayjs from '~/utils/dayjs';
import { validateRules } from '~/utils/validation';

const { $externalResults, catchError } = useFormRequestHandler();

const form = ref({
    name: '',
    default_contact_time_zone: 'America/New_York',
    parent_id: null,
    contact_groups: false,
    owner_name: '',
    owner_email: '',
    owner_phone: null,
    hubspot_company_id: null,
});

const validate = useVuelidate({ $externalResults });
const callout = useCallout();

const submitting = ref(false);
const submit = async () => {
    if (submitting.value) {
        return;
    }

    submitting.value = true;
    validate.value.$reset();

    if (!(await validateRules(validate))) {
        submitting.value = false;
        return;
    }

    try {
        const response = await adminTeamsClient.createTeam({
            ...form.value,
            owner_phone: e164Format(form.value.owner_phone),
        });

        if (response.data?.id) {
            callout.success('kiosk-team', `<strong>${escapeHtml(form.value.name)}</strong> Created successfully`, {
                ttl: dayjs().add(30, 'seconds'),
                action: {
                    text: 'Back to Teams',
                    href: '/kiosk/teams',
                },
                shadow: true,
            });

            window.location.assign(`/kiosk/teams/${response.data.id}`);
        }
    } catch (e) {
        catchError(e);
    } finally {
        submitting.value = false;
    }
};
</script>
